define(['jquery',
        'core/urls',
        'core/utilities',
        'components/modal',
        'components/request-time-manager',
        'bootstrap-toggle',
        'bootstrap-confirmation2',
    ],
    function ($, urls, utilities, modal, requestTM) {

        let dataTimeManager = new requestTM();

        let nodes = {
            modal: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: []
            },
            ssoError: document.querySelector('.sso-error-message'),
        }

        var createdModal = modal.create(nodes.modal, function (el) {
            document.querySelector('#id_enable_sso').checked = false;
        });

        let modalTemplate = document.querySelector(".modal-template-sso-warning")

        return {
            init: function () {
                // $('input[type="checkbox"]').bootstrapToggle();
                $('input[name="enable_2fa"]').on('change', function (e) {
                    setTimeout(function () {
                        $('#user-toggles').submit();
                    }, 200);
                });

                $('.enable-2fa_js').on('change', function (e) {
                    let checkbox = $(this);
                    let userId = checkbox.parents('tr').data('user-id');
                    let endpoint = '';
                    if (checkbox.is(':checked')) {
                        endpoint = urls['account:enable-2fa']();
                    } else {
                        endpoint = urls['account:disable-2fa']();
                    }
                    $.post(endpoint, {
                        'user_id': userId
                    });
                });

                // ---------------
                // USER MANAGEMENT
                // ---------------

                utilities.confirmationTooltip("reset-2fa", (data) => {
                    let userId = data.id;
                    let resetEndpoint = urls['account:reset-2fa']();
                    $.post(resetEndpoint, {
                        'user_id': userId
                    }).done(function () {
                        location.reload();
                    });
                })

                utilities.confirmationTooltip("delete-user", (data) => {
                    let userId = data.id;
                    let endpoint = urls['account:update-user'](userId);
                    $.ajax(endpoint, {
                        type: 'DELETE',
                        success: function () {
                            location.reload();
                        }
                    });
                })

                $('.sso-toggle-wrap input').on('click', function (e) {
                    createdModal.open(null, function (el) {
                        const confirmButton = el.querySelector(".confirm");
                        const cancelButton = el.querySelector(".close-sb-modal_js");
                        confirmButton.addEventListener("click", function (e) {
                            confirmButton.classList.add('loading');
                            e.preventDefault();
                            fetch(urls['account:enable-account-sso'](), {
                                method: 'POST',
                                headers: {
                                    'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value
                                }
                            })
                            .then(function (response) {
                                if (!response.ok) {
                                    throw new Error();
                                }
                                return response.json();
                            })
                            .then(function (data) {

                                if(data.error) {
                                    nodes.ssoError.innerHTML = data.error;
                                    nodes.ssoError.classList.remove('hide');
                                    document.querySelector('#id_enable_sso').checked = false;
                                    createdModal.close();
                                    confirmButton.classList.remove('loading');
                                    return;
                                }

                                let taskId = data.task_id;
                                let taskUrl = urls['task_check'](taskId);

                                dataTimeManager.start();

                                let taskCheck = async () => {
                                    await fetch(taskUrl, {
                                        method: "GET",
                                    })
                                    .then(response => response.json())
                                    .then((taskData) => {
                                        if(taskData.done) {
                                            dataTimeManager.abort();
                                            confirmButton.classList.remove('loading');
                                            location.reload();
                                        }
                                    })        
                                };

                                dataTimeManager.interval(taskCheck);
                                
                            })
                            .catch(function () {
                                document.querySelector('#id_enable_sso').checked = false;
                                createdModal.close();
                                confirmButton.classList.remove('loading');
                            });
                        });
                    }, modalTemplate); 
                });
            }
        };
    }
);